import axios from "axios";
import type { AccountType } from "@multiversx/sdk-dapp/types";
import { getEconomics } from "@multiversx/sdk-dapp/apiCalls/economics";

import { API_URL } from "@/config";
import { accountToEgldToken } from "@/utils/token.helper";
import { TokenType } from "@/types/token.types";
import { NftType } from "@/types/nft.types";

export class MultiversxService {
  static getTokens = async (address: string): Promise<TokenType[]> => {
    const esdtsPromise = axios.get(
      `${API_URL}/accounts/${address}/tokens?size=10000`
    );

    const accountPromise = axios.get<AccountType>(
      `${API_URL}/accounts/${address}`
    );

    const economicsPromise = getEconomics();

    const [esdts, account, economics] = await Promise.all([
      esdtsPromise,
      accountPromise,
      economicsPromise,
    ]);

    const egldToken = accountToEgldToken(account.data, economics.data);

    return [egldToken, ...esdts.data];
  };

  static async getNfts(address: string): Promise<NftType[]> {
    const { data } = await axios.get<NftType[]>(
      `${API_URL}/accounts/${address}/nfts?size=1000`
    );
    return data;
  }

  // static async getDelegationInfo(): Promise<DelegationType[]> {
  //   // let { data } = await axios.get<DelegationType[]>(
  //   //   `${API_URL}/accounts/${address}/delegation`
  //   // );

  //   // data = data.slice(0, 5);
  //   // const pulsarMoneyProviders = [
  //   //   'erd1qqqqqqqqqqqqqqqpqqqqqqqqqqqqqqqqqqqqqqqqqqqqpq8llllskj52rl',
  //   //   'erd1qqqqqqqqqqqqqqqpqqqqqqqqqqqqqqqqqqqqqqqqqqqqpg8llllsauamua',
  //   // ];

  //   // const providerInfo = await Promise.all(
  //   //   pulsarMoneyProviders.map(contractAddress => {
  //   //     return axios.get<ProviderInfo>(
  //   //       `${API_URL}/providers/${contractAddress}`
  //   //     );
  //   //   })
  //   // );

  //   // providerInfo.forEach((provider, index) => {
  //   //   data[index].providerInfo = {
  //   //     ...provider.data,
  //   //     avatar: `https://raw.githubusercontent.com/multiversx/mx-assets/master/identities/${provider.data.identity}/logo.png`,
  //   //   };
  //   // });

  //   return delegationDummy;
  // }

  // static getTokenPrices = async () => {
  //   const economicsPromise = getEconomics();
  //   const esdtsPromise = axios.get<xExchangeToken[]>(
  //     `${API_URL}/mex/tokens?size=1000`
  //   );

  //   const [economics, esdts] = await Promise.all([
  //     economicsPromise,
  //     esdtsPromise,
  //   ]);

  //   const tokens = esdts.data;
  //   tokens.push({
  //     id: EGLD,
  //     name: "MultiversX",
  //     price: economics.data.price,
  //     previous24hPrice: 0,
  //     symbol: EGLD,
  //   });

  //   return tokens;
  // };

  // static getRecentTransfers = async (
  //   address: string
  // ): Promise<RecentTransfers[]> => {
  //   const { data } = await axios.get<TransactionType[]>(
  //     `${API_URL}/accounts/${address}/transfers`,
  //     {
  //       params: {
  //         size: 50,
  //         sender: address,
  //         status: "success",
  //         withUsername: true,
  //       },
  //     }
  //   );
  //   const validFunctions = [
  //     TransactionMethodsEnum.transfer,
  //     TransactionMethodsEnum.ESDTTransfer,
  //   ];

  //   const filtered = data
  //     .filter(
  //       (t) =>
  //         t.function &&
  //         validFunctions.includes(t.function as TransactionMethodsEnum)
  //     )
  //     .map(
  //       (t) =>
  //         ({
  //           address: t.receiver,
  //           herotag: t.receiverAssets?.name,
  //         } as RecentTransfers)
  //     );

  //   const unique = Array.from(new Set(filtered.map((a) => a.address))).map(
  //     (addr) => {
  //       return filtered.find((a) => a.address === addr);
  //     }
  //   ) as RecentTransfers[];

  //   return unique;
  // };

  // static async getTokenDetails(tokenId: string): Promise<TokenDetailsResponse> {
  //   const { data } = await axios.get<TokenDetailsResponse>(
  //     `${API_URL}/tokens/${tokenId}`
  //   );
  //   return data;
  // }
}
